"use strict";

let GameCreateForm = {
    options: {
        selector: 'form.game-create-form',
        partSelector: '.game-form-part',
        buttonAddSelector: 'button.add-part-button',
        buttonRemoveSelector: 'button.remove-part-button',
        partCountSelector: 'input[name="part_count"]',
    },
};

GameCreateForm.init = function (userOptions) {
    for (const prop in userOptions) {
        if (Object.prototype.hasOwnProperty.call(this.options, prop)) {
            this.options[prop] = userOptions[prop];
        }
    }

    this.initSelectors(document);
}

GameCreateForm.initSelectors = function (rootElement) {
    const elements = rootElement.querySelectorAll(this.options.selector);
    elements.forEach((form) => {
        if (form.hasOwnProperty('moduleGameCreateFormInitialized')) { return; }
        form.moduleGameCreateFormInitialized = true;

        const removeButton = form.querySelector(this.options.buttonRemoveSelector);
        const addButton = form.querySelector(this.options.buttonAddSelector);
        const partCount = form.querySelector(this.options.partCountSelector);

        //this.updateRemoveButton(removeButton, form);

        /*removeButton.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            e.stopImmediatePropagation();

            const parts = form.querySelectorAll(this.options.partSelector);

            if (parts.length <= 1) return;

            parts[parts.length - 1].remove();

            partCount.value = parts.length - 1;

            this.updateRemoveButton(removeButton, form);
        });*/

        addButton.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            e.stopImmediatePropagation();

            const parts = form.querySelectorAll(this.options.partSelector);

            const last_part = parts[parts.length - 1];
            last_part.parentNode.insertBefore(this.clonePart(last_part), last_part.nextSibling);

            partCount.value = parts.length + 1;

            this.reindexParts(form)
        })

        form.querySelectorAll(this.options.partSelector).forEach((part) => {
            this.initPart(part, form);
        });
        this.updateButtons(form)
    });
}

GameCreateForm.reindexParts = function (form) {
    const parts = form.querySelectorAll(this.options.partSelector);
    parts.forEach((part, index) => {
        const label = part.querySelector(".game-part-label");
        const number = (index + 1).toString()
        const old_number = label.innerText.replace(/\D/g, "");
        if (old_number === number) return;

        label.innerHTML = number + label.innerText.replace(/\d/g, "");
        const new_name_prefix = 'part_' + number;
        const old_name_prefix = 'part_' + old_number;
        part.querySelectorAll('input, textarea').forEach((input) => {
            input.name = new_name_prefix + input.name.substring(old_name_prefix.length);
        });
    });
    this.updateButtons(form)
}

GameCreateForm.initPart = function (part, form) {
    part.querySelectorAll(".part-buttons").forEach((buttons) => {
        buttons.remove();
    });
    this.createPartButtons(part, form);
}

GameCreateForm.createPartButtons = function (part, form) {
    const buttons = document.createElement('div');
    buttons.classList.add('buttons');
    buttons.classList.add('part-buttons');

    const deleteButton = this.createButton("trash-can", "delete");
    deleteButton.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        part.remove();
        this.reindexParts(form);
    });

    const upButton = this.createButton("arrow-up", "up");
    upButton.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        part.parentNode.insertBefore(part, part.previousElementSibling);
        this.reindexParts(form);
    });

    const downButton = this.createButton("arrow-down", "down");
    downButton.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        part.parentNode.insertBefore(part, part.nextElementSibling.nextElementSibling);
        this.reindexParts(form);
    });

    buttons.insertBefore(upButton, null);
    buttons.insertBefore(downButton, null);
    buttons.insertBefore(deleteButton, null);
    part.insertBefore(buttons, part.firstElementChild);
}

GameCreateForm.updateButtons = function (form) {
    const buttonsElements = form.querySelectorAll(".part-buttons");
    if (buttonsElements.length <= 1) {
        buttonsElements.forEach((buttons) => {
            buttons.querySelector('.delete-part-button').disabled = true;
            buttons.querySelector('.up-part-button').disabled = true;
            buttons.querySelector('.down-part-button').disabled = true;
        });
    }else {
        const count = buttonsElements.length;
        let index = 0;
        buttonsElements.forEach((buttons) => {
            buttons.querySelector('.delete-part-button').disabled = false;
            buttons.querySelector('.up-part-button').disabled = index <= 0;
            buttons.querySelector('.down-part-button').disabled = (index + 1) >= count;
            index++;
        });
    }
}

GameCreateForm.clonePart = function (part) {
    const new_part = part.cloneNode(true);

    new_part.querySelectorAll("input").forEach(input => {
        input.value = "";
    });

    return new_part;
}

GameCreateForm.createButton = function (icon, name) {
    const button = document.createElement("button");
    button.classList.add(name + "-part-button");
    button.classList.add("button");
    button.classList.add("is-shadowless");
    button.classList.add("is-small");
    button.type = "button";
    button.innerHTML = "<span class=\"icon\"><i class=\"fas fa-"+icon+"\"></i></span>";
    return button;
}

export {GameCreateForm};